import { captureExceptionWithContext } from 'services/captureException';
import isEntityInformationTable from 'types/visTypeCheckers/isEntityInformationTable';
import isGauge from 'types/visTypeCheckers/isGauge';
import isGroupVsRemainder from 'types/visTypeCheckers/isGroupVsRemainder';
import isPaceMatrix from 'types/visTypeCheckers/isPaceMatrix';
import isRankingMatrix from 'types/visTypeCheckers/isRankingMatrix';
import isRemindersGadget from 'types/visTypeCheckers/isRemindersGadget';
import isSingleMetricDateMatrix from 'types/visTypeCheckers/isSingleMetricDateMatrix';
import isV5ChartDef from 'types/visTypeCheckers/isV5ChartDef';

const isUsedInChart = (
  metric: Metrics.NormalMetric | Metrics.CompoundMetric,
  // Undefined for a gadget saved without a chart definition
  def: VisualisationDefinition | undefined,
) => {
  if (!def) {
    return false;
  }

  if (isV5ChartDef(def)) {
    return def.series.some((s) => s.metricId === metric.id);
  } else if (isSingleMetricDateMatrix(def)) {
    return def.metricId === metric.id;
  } else if (isRankingMatrix(def)) {
    return def.metrics.some((m) => m.metricId === metric.id);
  } else if (isGauge(def)) {
    return def.metricId === metric.id;
  } else if (isRemindersGadget(def)) {
    return false;
  } else if (isPaceMatrix(def)) {
    return def.metricId === metric.id;
  } else if (isGroupVsRemainder(def)) {
    return false;
  } else if (isEntityInformationTable(def)) {
    return def.rows.some(
      (r) => r.type === 'metric' && r.metricId === metric.id,
    );
  } else {
    // Fails to compile when a new definition type is added but not handled
    // here. At runtime this only catches bad data.
    const unhandled: never = def;
    const { type, id } = unhandled as { type?: string; id?: string };
    const e = new Error(`type: ${type}`);
    e.name = `Unknown definition type`;
    captureExceptionWithContext({
      error: e,
      extra: { type, id },
      tags: { visType: type },
    });
    return false;
  }
};

export default isUsedInChart;
